import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { getMinutesAndSeconds } from '@hotjar/webapp/lib/getMinutesAndSeconds';
import { tokens } from '@hotjar/hotsauce';
import { useRealTimeStore } from '../store/realTimeStore';

export const TimeInfo = ({ id, duration, disabled = false }) => {
  const currentTimeWithLessPrecision = useRealTimeStore(
    (state) => state.currentTimeWithLessPrecision,
  );
  return (
    <span
      id={id}
      css={css`
        ${tokens.text('body2')}
        color: ${tokens.color.text_default};
        white-space: nowrap;

        &[disabled] {
          opacity: 0.25;
        }
      `}
      disabled={disabled}
    >
      {disabled
        ? '-:-- / -:--'
        : `${getMinutesAndSeconds(currentTimeWithLessPrecision)} / ${getMinutesAndSeconds(
            duration,
          )}`}
    </span>
  );
};

TimeInfo.defaultProps = {
  disabled: false,
  id: undefined,
};

TimeInfo.propTypes = {
  duration: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};
